<app-legal-layout [title]="title" [lastUpdated]="lastUpdated">
  <h2>1. Introducción</h2>
  <p>
    En <strong>velas.ar</strong>, nos comprometemos a proteger la privacidad y seguridad de la información personal de nuestros usuarios. 
    Esta Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos su información cuando visita nuestro sitio web 
    o utiliza nuestros servicios de venta de velas artesanales.
  </p>

  <h2>2. Información que Recopilamos</h2>
  <p>Recopilamos los siguientes tipos de información:</p>
  
  <h3>2.1. Información Personal</h3>
  <ul>
    <li>Nombre completo</li>
    <li>Dirección de correo electrónico</li>
    <li>Número de teléfono</li>
    <li>Dirección postal (para envíos)</li>
    <li>Información de pago (procesada de forma segura a través de terceros)</li>
  </ul>

  <h3>2.2. Información de Navegación</h3>
  <ul>
    <li>Dirección IP</li>
    <li>Tipo de navegador</li>
    <li>Páginas visitadas</li>
    <li>Tiempo de permanencia en el sitio</li>
  </ul>

  <h2>3. Uso de la Información</h2>
  <p>Utilizamos su información para los siguientes propósitos:</p>
  <ul>
    <li>Procesar y completar sus pedidos</li>
    <li>Enviar confirmaciones y actualizaciones sobre pedidos</li>
    <li>Responder a consultas y solicitudes de servicio al cliente</li>
    <li>Enviar comunicaciones promocionales (con su consentimiento)</li>
    <li>Mejorar nuestros servicios y experiencia del usuario</li>
    <li>Cumplir con obligaciones legales</li>
  </ul>

  <h2>4. Protección de Datos</h2>
  <p>
    Implementamos medidas de seguridad técnicas, administrativas y físicas para proteger su información personal contra acceso no autorizado, 
    alteración, divulgación o destrucción. Esto incluye:
  </p>
  <ul>
    <li>Encriptación SSL/TLS para transmisiones de datos</li>
    <li>Acceso restringido a información personal</li>
    <li>Sistemas de seguridad actualizados regularmente</li>
    <li>Procesamiento seguro de pagos a través de proveedores certificados</li>
  </ul>

  <h2>5. Compartir Información</h2>
  <p>
    No vendemos, alquilamos ni compartimos su información personal con terceros, excepto en las siguientes circunstancias:
  </p>
  <ul>
    <li><strong>Proveedores de servicios:</strong> Compartimos información con proveedores que nos ayudan a operar nuestro negocio (procesamiento de pagos, envíos, hosting).</li>
    <li><strong>Requisitos legales:</strong> Cuando sea requerido por ley o para proteger nuestros derechos legales.</li>
    <li><strong>Consentimiento:</strong> Con su consentimiento explícito.</li>
  </ul>

  <h2>6. Cookies y Tecnologías Similares</h2>
  <p>
    Utilizamos cookies y tecnologías similares para mejorar su experiencia en nuestro sitio web, analizar el tráfico del sitio y personalizar contenido. 
    Puede gestionar sus preferencias de cookies a través de la configuración de su navegador.
  </p>

  <h2>7. Sus Derechos</h2>
  <p>
    De acuerdo con la ley de protección de datos, usted tiene derecho a:
  </p>
  <ul>
    <li>Acceder a su información personal</li>
    <li>Rectificar información incorrecta o incompleta</li>
    <li>Solicitar la eliminación de sus datos personales</li>
    <li>Oponerse al procesamiento de sus datos</li>
    <li>Retirar su consentimiento en cualquier momento</li>
  </ul>

  <h2>8. Enlaces a Sitios Externos</h2>
  <p>
    Nuestro sitio web puede contener enlaces a sitios externos. No somos responsables de las prácticas de privacidad de estos sitios. 
    Le recomendamos revisar las políticas de privacidad de cada sitio que visite.
  </p>

  <h2>9. Menores de Edad</h2>
  <p>
    Nuestro sitio web no está dirigido a menores de 18 años. No recopilamos intencionalmente información personal de menores de edad. 
    Si descubrimos que hemos recopilado información de un menor, la eliminaremos inmediatamente.
  </p>

  <h2>10. Cambios a esta Política</h2>
  <p>
    Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Le notificaremos sobre cambios importantes 
    mediante un aviso prominente en nuestro sitio web o por correo electrónico.
  </p>

  <h2>11. Contacto</h2>
  <p>
    Si tiene preguntas sobre esta Política de Privacidad o desea ejercer sus derechos, puede contactarnos:
  </p>
  <ul>
    <li><strong>Email:</strong> info@velas.ar</li>
    <li><strong>Teléfono:</strong> +54 9 3329-564190</li>
    <li><strong>Dirección:</strong> Baradero, Buenos Aires, Argentina</li>
  </ul>

  <p style="margin-top: 3rem; padding-top: 2rem; border-top: 2px solid #ad5d56;">
    <strong>Al utilizar nuestro sitio web y servicios, usted acepta los términos de esta Política de Privacidad.</strong>
  </p>
</app-legal-layout>

